/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import Typography from "@mui/material/Typography"
import { BOUNDARYNODEEERROR, ERRORLIST, IBoundaryNodeError, IDataErrorList, IExtractionError } from "../../../Models/IErrorList"
import mikeSharedTheme from '../../../styles/mikeSharedTheme';

const notificationTextStyle = css` 
  padding-bottom: ${mikeSharedTheme.spacing(1)};
`;

const containerStyle = css` 
  padding-top: ${mikeSharedTheme.spacing(1)};
  padding-bottom: ${mikeSharedTheme.spacing(1)};
`;

const childNotificationTextStyle = css` 
  padding-left: ${mikeSharedTheme.spacing(1)};
`;

const renderChildErrors = (error: any) => {
 if (error.ErrorType === BOUNDARYNODEEERROR){

  const boundaryNodeError: IBoundaryNodeError = error
  return (
    <div css={childNotificationTextStyle}>
      <Typography variant="body2">{boundaryNodeError.ErrorMessage}</Typography>
      <Typography variant="body2">{boundaryNodeError.Id + " " + boundaryNodeError.X + " " + boundaryNodeError.Y}</Typography>
    </div>    
  )
 }
}

const renderExtractionError = (extractionError: IExtractionError) => {
  return (
    <div css={notificationTextStyle}>
      <Typography variant="body2">{extractionError.ErrorMessage}</Typography>
      <Typography variant="body2">{extractionError.ExtractionType + " - " + extractionError.ProviderName + " - " + extractionError.ItemName}</Typography>
       {extractionError.ChildErrors.Errors.map((error: any) => renderChildErrors(error))} 
    </div>
  )

}

export const renderStatus = (errorList: IDataErrorList) => {
 
  if (errorList && errorList.ErrorType === ERRORLIST){
    return (
      <div css={containerStyle}>
        <Typography variant="body2">{"Failed:"}</Typography>
        {errorList.Errors.map((error: any) => renderExtractionError(error))}
      </div>
    )
  }
 else{
  return undefined
 }
}